import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Box, Button, Grid, Tooltip } from "@mui/material";
import { useHistory, withRouter } from "react-router-dom";
import { createTheme } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import createCache from "@emotion/cache";
import useCollapse from "react-collapsed";
import { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { Formik } from "formik";
import { createStyles, Theme, makeStyles } from "@material-ui/core";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../../models/common.model";
import { STOREID, TABLE_FILTER } from "../../../config/cacheKey";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import ChipCmp from "../../../components/chip/chipCmp";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  Filter,
  GetStoreListResponse,
  PaginationInfo,
  StorePage,
} from "../../../models/store.model";
import {
  DeleteStore,
  GetStoreList,
  GetStoreListReportExcel,
} from "../../../services/store.service";
import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ModalCancel from "../../../components/modals/ModalCancel";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AutocomplateCheckbox from "../../../components/dropdown/AutocomplateCheckbox";
import { CacheProvider, ThemeProvider } from "@emotion/react";

// const useStyles = makeStyles((theme) =>
//   createStyles({
//     select: {
//       "&.Mui-selected": {
//         backgroundColor: muiSelected,
//       },
//     },
//   })
// );

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "title", label: "عنوان فروشگاه" },
  { id: "percentage", label: "سهم تسویه حساب" },
  {
    id: "settlementDeadlineDays",
    label: "مهلت تسویه حساب",
  },
  {
    id: "isActive",
    label: "وضعیت فروشگاه",
  },
];

export default function Store() {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [delId, setDelId] = useState<number>();
  const jsonFile = useSelector((state: any) => state.style);

  // const muiSelected = jsonFile?.secondColor_100;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: "#82B1FF !important",
        },
      },
    })
  );
  const classes = useStyles();
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();

  let row: any;
  const queryClient = useQueryClient();
  const history = useHistory<{
    from: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();
  const [isExpanded, setExpanded] = useState(true);
  const [data, setData] = useState<GetStoreListResponse[]>([]);
  const [allData, setAllData] = useState<GetStoreListResponse[]>([]);
  const [storeActive, setStoreActive] = useState<
    { id: number; title: string; enumData: boolean }[]
  >([]);
  const [valueTitle, setValueTitle] = useState<any[]>([]);
  const [valueId, setValueId] = useState<any[]>([]);
  const [inputVal, setInputVal] = useState<string>("");
  const [valueTitleResponse, setValueTitleResponse] = useState<any[]>([]);
  const [valueIsActive, setValueIsActive] = useState<string>();
  const [valueIsActiveSelect, setValueIsActiveSelect] = useState<boolean>();
  const [selectedRow, setSelectedRow] = useState(undefined);
  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;

  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );

  React.useEffect(() => {
    let request = {} as StorePage;
    let pageInfoModel = new PageInfoModel();
    pageInfoModel.pageNumber = -1;
    pageInfoModel.pageSize = 1000;
    request.paginationInfo = pageInfoModel;
    // request.filter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    GetAllStoreListMutate(request);

    const storeStatusOptions = [
      { id: 1, title: "فعال", enumData: true },
      { id: 2, title: "غیرفعال", enumData: false },
    ];
    setStoreActive(storeStatusOptions);

    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        setValueTitle([filterData!.title!]);
        setValueIsActiveSelect(filterData!.isActive!);
      }
    } else {
      filterData = null;
      queryClient.setQueryData(TABLE_FILTER, null);
      let filter = new Filter();
      setValueFilterData(filter);
    }
    fillData(filterData!);
  }, []);

  const { mutateAsync: GetStoreListMutate } = useMutation(GetStoreList, {
    onSuccess: (data: ApiResultModel<GetStoreListResponse[]>) => {
      setData(data.data!);
      setPageInfo(data.pageInfo);
      setInputVal("");
    },
  });
  const { mutateAsync: GetAllStoreListMutate } = useMutation(GetStoreList, {
    onSuccess: (data: ApiResultModel<GetStoreListResponse[]>) => {
      setAllData(data.data!);
    },
  });
  const { mutateAsync: DeleteStoreMutate } = useMutation(DeleteStore, {
    onSuccess: (data: ApiResultModel<string>) => {
      if (data.isSuccess === true) {
        toast.success(data.data);
        const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
        fillData(tabelFilter!);
        // let filter = generateFilter(filterData);
        // GetStoreListMutate(filter);
      } else toast.error(data.data);
    },
  });

  const { mutateAsync: GetStoreListReportExcelMutate } = useMutation(
    GetStoreListReportExcel,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );
  const setChildValueTitle = (childValues: any) => {
    let delValue = allData.filter((item: any) => item.title === childValues);
    let titleValue = valueTitle.filter((item: any) => item !== childValues);
    setValueTitle(titleValue);

    const updatedRenderOption = valueTitleResponse?.filter(
      (item: any) => item.id !== delValue[0].id
    );
    setValueTitleResponse(updatedRenderOption);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    const updatedFilter = tabelFilter?.storeIds?.filter(
      (id: number) => id !== delValue[0].id
    );
    setValueId(updatedFilter ?? []);
    if (updatedFilter !== undefined && updatedFilter !== null) {
      tabelFilter!.storeIds = updatedFilter;
    }

    if (tabelFilter !== undefined && tabelFilter !== null)
      tabelFilter!.title = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueIsActive = (childValues: any) => {
    const selectedItem = undefined;
    setValueIsActiveSelect(selectedItem);
    setValueIsActive("");
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined) tabelFilter!.isActive = undefined;
    fillData(tabelFilter!);
  };

  const handleSelectedIsActive = (e: any, value: any) => {
    setValueIsActiveSelect(e.target.value!);
    setValueIsActive(value.props.children!);
  };

  const generateFilter = (filterData: Filter): StorePage => {
    let request = {} as StorePage;
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    GetStoreListMutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
  };

  function changeValueTitle(e: any, value: any) {
    setValueTitle(value.map((item: any) => item.title));
    setValueId(value.map((item: any) => item.id));
    setValueTitleResponse(value);
  }

  function deleteChip() {
    setValueTitleResponse([]);
    setValueTitle([]);
    setValueId([]);
    setValueIsActive("");
    setValueIsActiveSelect(undefined);
    queryClient.setQueryData(TABLE_FILTER, null);
    fillData(queryClient.getQueryData(TABLE_FILTER)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = new Filter();
  const handelDetail = (id: number) => {
    history.push({
      pathname: "/store/StoreDetail",
    });
    localStorage.setItem(STOREID, id.toString());
  };

  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  let exportExcel = () => {
    GetStoreListReportExcelMutate(
      valueFilterData ? valueFilterData! : new Filter()
    );
  };

  const addStore = () => {
    history.push({
      pathname: "/createStore",
      state: {
        from: "store",
        pageNumber: 1,
        clickOnBack: false,
      },
    });
  };
  const openModalDeleteImage = () => {
    setOpenModal(!openModal);
  };
  const deleteImage = () => {
    DeleteStoreMutate({ storeId: delId! });
  };
  return (
    <div>
      <Button onClick={addStore}>
        <AddCircleOutlineIcon />
        <span
          style={{ fontWeight: "bold", fontSize: "14px", paddingRight: "5px" }}
        >
          افزودن فروشگاه
        </span>
      </Button>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title="فیلتر" arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/filter.png"
        />
      </Tooltip>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title="خروجی اکسل" arrow>
        <img
          onClick={exportExcel}
          className="cursorPointer"
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/ExportXLS.svg"
        />
      </Tooltip>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values: any) => {
              queryClient.setQueryData(TABLE_FILTER, values);
              // values.title = valueTitle;
              values.isActive = valueIsActiveSelect;
              values.storeIds = valueId;
              setInputVal("send");
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <CacheProvider value={cacheRtl}>
                    <ThemeProvider theme={theme}>
                      <div
                        className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                        style={{ paddingTop: "30px", direction: "rtl" }}
                      >
                        <AutocomplateCheckbox
                          id="addValue"
                          name="addValue"
                          value={valueId}
                          label={"عنوان فروشگاه"}
                          options={allData!}
                          onChange={changeValueTitle}
                          changeMultiSelect={changeValueTitle}
                          responseValue={valueTitleResponse}
                          inputVal={inputVal}
                        />
                      </div>
                    </ThemeProvider>
                  </CacheProvider>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <DropdownCmp2
                      onChange={handleSelectedIsActive}
                      value={valueIsActiveSelect ?? ""}
                      label={"وضعیت فروشگاه *"}
                      options={storeActive}
                      name="isActive"
                      id="isActive"
                      paddingRight={"0px"}
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ paddingTop: "30px" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>

                {valueTitle.length > 0 || valueIsActiveSelect?.valueOf ? (
                  <div className="row chipMargin">
                    <Grid container xs={12}>
                      <Grid
                        item
                        xs={0.5}
                        style={{ marginTop: "10px", maxWidth: "fit-content" }}
                      >
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src="images/RemoveAllFilters.svg"
                          />
                        </Button>
                      </Grid>
                      <Grid item xs={11.5}>
                        {valueTitle.map((title, index) => (
                          <ChipCmp
                            key={index}
                            item={title}
                            enamValue={title}
                            index={index}
                            setChildValue={setChildValueTitle}
                          />
                        ))}
                        <ChipCmp
                          item={valueIsActive}
                          enamValue={valueIsActive}
                          index={valueIsActive?.length}
                          setChildValue={setChildValueIsActive}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />
      <div className="cardTableBorder ">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className={`${data?.length > 0 ? "boxScrollSubmit" : ""}`}
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell>
                {columns?.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  <MoreHorizIcon />
                </TableCell>
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>

            <TableBody
              style={{
                height: "30px",
                minHeight: "30px",
              }}
            >
              {data?.map((row, rowIndex) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft cursorPointer noWrap`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    // key={row.loanRequestId}
                    selected={selectedRow === rowIndex}
                  >
                    <TableCell className="textFont12" style={{ width: "5px" }}>
                      {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                        (currentPaginationInfo.pageSize! ?? 0) +
                        rowIndex +
                        1}
                    </TableCell>
                    {columns?.map((column) => {
                      const value =
                        row[column.id as keyof GetStoreListResponse];
                      return (
                        <TableCell
                          onClick={() => handelDetail(row.id)}
                          className="textFont12 nowrapClass"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat ? (
                            column.format(value)
                          ) : column.id === "isActive" ? (
                            value === true ? (
                              <b style={{ color: "#28A745" }}>فعال</b>
                            ) : (
                              <b style={{ color: "#E6123D" }}>غیرفعال</b>
                            )
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                    <TableCell
                      align="center"
                      component="th"
                      scope="row"
                      onClick={() => {
                        openModalDeleteImage();
                        setDelId(row.id);
                      }}
                      sx={{ cursor: "pointer", color: "#1D4A87" }}
                      className="textFont12 nowrapClass"
                    >
                      <DeleteOutlineIcon />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :{" "}
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>

          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={Math.ceil(pageInfo.total / pageInfo.pageSize)}
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>

          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
      {openModal === true ? (
        <ModalCancel
          title={""}
          bgColor={"kamanColor"}
          setValue={deleteImage}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
      ) : (
        ""
      )}
    </div>
  );
}
